import { normalizeTs, toTaipeiISODate } from '../lib/time';

const toMs = (ts) => {
  try {
    return new Date(normalizeTs(ts)).getTime();
  } catch {
    return 0;
  }
};

export const aggregateFirstLastMinutes = (records, { startISO, endISO, holidaySet } = {}) => {
  const perEmployeeMinutes = {};
  const perEmployeeDates = {};
  const holidayDates = holidaySet instanceof Set ? holidaySet : null;

  const withinRange = (dateISO) => {
    if (!startISO || !endISO) return true;
    return dateISO >= startISO && dateISO <= endISO;
  };

  const keyOf = (empId, dateISO) => `${String(empId)}-${dateISO}`;

  const grouped = {};

  (records || []).forEach((r) => {
    const empId = r?.user_id;
    const ts = r?.timestamp;
    if (!empId || !ts) return;
    let dateISO;
    try {
      dateISO = toTaipeiISODate(ts);
    } catch {
      return;
    }
    if (!dateISO) return;
    if (!withinRange(dateISO)) return;
    if (holidayDates && holidayDates.has(dateISO)) return;

    const type = String(r?.type || '').toLowerCase().trim();
    if (type !== 'time_in' && type !== 'time_out') return;

    const k = keyOf(empId, dateISO);
    if (!grouped[k]) grouped[k] = { empId: String(empId), dateISO, firstIn: null, lastOut: null };

    if (type === 'time_in') {
      if (!grouped[k].firstIn || toMs(ts) < toMs(grouped[k].firstIn.timestamp)) grouped[k].firstIn = r;
    } else {
      if (!grouped[k].lastOut || toMs(ts) > toMs(grouped[k].lastOut.timestamp)) grouped[k].lastOut = r;
    }
  });

  Object.values(grouped).forEach((g) => {
    const empId = g.empId;
    const dateISO = g.dateISO;

    if (!perEmployeeMinutes[empId]) perEmployeeMinutes[empId] = { late: 0, undertime: 0 };
    if (!perEmployeeDates[empId]) perEmployeeDates[empId] = {};
    if (!perEmployeeDates[empId][dateISO]) {
      perEmployeeDates[empId][dateISO] = { has_time_in: false, has_time_out: false, first_in: null, last_out: null };
    }

    const day = perEmployeeDates[empId][dateISO];
    if (g.firstIn) {
      day.has_time_in = true;
      day.first_in = g.firstIn.timestamp;
      perEmployeeMinutes[empId].late += g.firstIn.late_minutes || 0;
    }
    if (g.lastOut) {
      day.has_time_out = true;
      day.last_out = g.lastOut.timestamp;
      perEmployeeMinutes[empId].undertime += g.lastOut.undertime_minutes || 0;
    }
  });

  return { perEmployeeMinutes, perEmployeeDates };
};

export default { aggregateFirstLastMinutes };

